import { render } from "./FileUpload.vue?vue&type=template&id=6dfc8065&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"

import "./FileUpload.vue?vue&type=style&index=0&id=6dfc8065&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfc8065"]])

export default __exports__